import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { useGlobalEffectActions, usePageContext } from "@ryde/redux";
import { nearByFilterAtomFamily, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";
import { deepPurpleMui, greyMui } from "@ryde/theme";

import { NearByButtonStyled } from "./elements.styled";

export const RidesNearByButton: FC = () => {
  const { entity } = usePageContext();
  const [nearByFilterIsActive, setNearByFilterIsActive] = useRecoilState(
    nearByFilterAtomFamily(entity),
  );
  const { resetPaginationAppEvent } = useGlobalEffectActions();
  const { t } = useTranslation();

  const onClick = (): void => {
    setNearByFilterIsActive(!nearByFilterIsActive);
    resetPaginationAppEvent();
  };

  const color = nearByFilterIsActive ? deepPurpleMui.A700 : greyMui._600;

  return (
    <FramerTooltip
      content={t("ui.Nearby")}
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <NearByButtonStyled onClick={onClick}>
        {nearByFilterIsActive && (
          <SVG_MUI.FunnelHasNearby5SVG
            className="nearby_funnel"
            data-e2e="funnel_outline"
          />
        )}
        {!nearByFilterIsActive && (
          <SVG_MUI.Filter2SVG
            className="nearby_funnel"
            data-e2e="funnel_outline"
          />
        )}
        <label style={{ color }}>{t("ui.Nearby")}</label>
      </NearByButtonStyled>
    </FramerTooltip>
  );
};
